import { RegistrationController } from './registration.controller';

export const RegistrationComponent: ng.IComponentOptions = {
    template: require('./registration.html'),
    controller: RegistrationController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/registration.component.ts